import { createPinia } from 'pinia';
import { createPiniaSentryPlugin } from '../errors/sentry';

/**
 * The Pinia instance both entries install, carrying the allowlist-only Sentry plugin (EN-961).
 * Install PiniaColada after it: `app.use(pinia).use(PiniaColada)`.
 *
 * @returns {import('pinia').Pinia}
 */
export const createAppPinia = () => {
	const pinia = createPinia();

	pinia.use(createPiniaSentryPlugin());

	return pinia;
};
